import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute } from '@angular/router';
import { MediaCellConfig } from 'angular-engine/modules/ng-express-engine/tokens';
import * as moment from 'moment';
import { timer } from 'rxjs/observable/timer';

@Component({
    selector: "date-select-list",
    templateUrl: "./date-select-list.template.html",
    styles: [`
        .date-picker {
            display: block;
            margin-bottom: 30px;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DateSelectList implements OnInit {
    @Input() list: any;
    // @Input() select: string;
    @Input() config: MediaCellConfig;
    @Input() paginate: Boolean;
    @Input() content$: any;
    @Input() selectedDate:any = new Date();

    // selectItems:Array<any>;
    selectedItem: any;

    private subscriptions: Array<any> = [];
    private dataService: BehaviorSubject<Object>;

    public zIndex = 0;

    constructor(
        private effects: CoreEffects,
        private ref: ChangeDetectorRef
    ) {
        this.dataService = new BehaviorSubject(null);
    }

    ngOnInit() {
        this.content$ = this.dataService.asObservable();
        this.subscriptions.push(this.content$.subscribe(content => {
            if (content && content.data) {
                this.selectedItem = content
            }
        }));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.list && changes.list.currentValue !== changes.list.previousValue) {
            if (this.list.data) {
                this.dataService.next(this.list)
            } else {
               this.requestDataByDate(moment(this.selectedDate))
            }
        }
    }

    ngAfterViewInit(){
        const source = timer(2000);
        const subscribe = source.subscribe(val => {
            this.zIndex=1;
            this.ref.detectChanges();
        });
    }

    //expected object is a MomentJs instance
    requestDataByDate(date:any) {
        this.effects.getSeriesDailyEpisodeDataEmit(this.dataService, this.list.meta, date.format("D-M-YYYY"))
    }

    onDateChanged(date) { 
        this.requestDataByDate(date)
    }

    ngOnDestroy() {
        if (this.dataService){
            this.dataService.complete();
            //this.dataService.unsubscribe();
            this.dataService = null;
        }
        this.subscriptions.forEach(s => s.unsubscribe())
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/list/date-select-list/date-select-list.component.ts